<template>
  <b-container fluid>
    <b-form @submit.prevent>
      <b-row no-gutters class="bordered-box-header">
        <h2>Wiadomości</h2>
      </b-row>
      <b-row no-gutters class="bordered-box">
        <b-container fluid>
          <b-row class="justify-content-center" v-if="!loaded && loading">
            <b-spinner big label="Loading..."></b-spinner>
          </b-row>

          <b-row v-else-if="loaded">
            <b-container fluid>
              <b-row style="margin-bottom: 8px;">
                <b-col style="padding: 0px;">
                  <b-form-group class="required" label="Użytkownicy">
                    <multiselect
                      v-model="selectedUsers"
                      track-by="id"
                      label="fullName"
                      placeholder="Wybierz użytkowników"
                      :options="users"
                      :allow-empty="true"
                      :multiple="true"
                      :internal-search="false"
                      :searchable="false"
                      group-values="users"
                      group-label="role"
                      :group-select="true"
                    >
                    </multiselect>
                    <div v-if="this.selectedUsersAreEmpty" class="invalid-feedback" style="display: block;"><div>To pole jest wymagane</div></div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row style="margin-bottom: 8px;">
                <b-col style="padding: 0px;">
                  <b-form-group class="required" label="Tytuł">
                    <b-form-input
                      v-model="title"
                      type="text"
                      autocomplete="off"
                    />
                    <div v-if="this.titleIsEmpty" class="invalid-feedback" style="display: block;"><div>To pole jest wymagane</div></div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col style="padding: 0px;">
                  <b-form-group class="required" label="Treść">
                    <vue-editor
                      class="required"
                      v-model="content"
                      style="width: 100%; height: 100%;"
                    />
                    <div v-if="this.contentIsEmpty" class="invalid-feedback" style="display: block;"><div>To pole jest wymagane</div></div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col style="padding: 0px; margin-top: 16px;">
                  <b-form-group>
                    <b-button
                      class="float-right"
                      type="button"
                      variant="primary"
                      @click="onSend()"
                    >
                      Wyślij
                    </b-button>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-row>
        </b-container>
      </b-row>

      <b-modal id="sendConfirm" title="Wyślij">
        <b-container style="text-align: left;">
          Czy na pewno chcesz wysłać wiadomość do wybranych użytkowników?
        </b-container>
      
        <template slot="modal-footer">
          <b-container>
            <b-row>
              <b-col style="text-align: right; padding-right: 0px;">
                <b-button variant="secondary" @click="$bvModal.hide('sendConfirm')" style="margin-right: 4px;">Anuluj</b-button>
                <b-button variant="primary" :disabled="saving" @click="onSubmit()">
                  <span v-show="!saving">Wyślij</span>
                  <span v-show="saving">
                    <b-spinner small label="Proszę czekać..."></b-spinner>
                  </span>
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </template>
      </b-modal>
    </b-form>
  </b-container>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { VueEditor } from "vue2-editor";
import multiselect from "vue-multiselect";

export default {
  components: { multiselect, VueEditor },
  data() {
    return {
      titleIsEmpty: false,
      contentIsEmpty: false,
      selectedUsersAreEmpty: false,
      title: null,
      content: null,
      loading: false,
      loaded: false,
      saving: false,
      users: [],
      selectedUsers: [],
    };
  },
  methods: {
    onSend() {
      this.titleIsEmpty = this.title == null || this.title == "";
      this.contentIsEmpty = this.content == null || this.content == "";
      this.selectedUsersAreEmpty = this.selectedUsers == null || this.selectedUsers.length == 0;

      if (!this.titleIsEmpty && !this.contentIsEmpty && !this.selectedUsersAreEmpty) {
        this.$bvModal.show('sendConfirm');
      }
    },
    onSubmit() {
      let self = this;

      axios
        .post("settings/sendemails", {
            UserIds: self.selectedUsers.map(function (item) { return item.id; }),
            Title: self.title,
            Content: self.content
        })
        // eslint-disable-next-line
        .then(response => {
          eventBus.$emit("notify-success", "Wysłano pomyślnie.");

          self.selectedUsers = [];
          self.title = null;
          self.content = null;
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.saving = false;
          this.$bvModal.hide('sendConfirm');
        });
    },
    async getLectors() {
      let self = this;

      await axios
        .get("lectors/list")
        .then(response => {
          var lectors = [];

          response.data.forEach(element => {
            var fullName = element.firstName + ' ' + element.lastName;
            lectors.push({
              id: element.id,
              fullName: fullName
            });
          });

          self.users.push({
            role: 'Lektorzy',
            users: lectors
          });
        })
        .catch(error => {
          eventBus.$emit("unhandled-error", error);
        });
    },
    async getStudents() {
      let self = this;

      await axios
        .get("students/all")
        .then(response => {
          var students = [];

          response.data.forEach(element => {
            var fullName = element.firstName + ' ' + element.lastName;
            students.push({
              id: element.id,
              fullName: fullName
            });
          });

          self.users.push({
            role: 'Kursanci',
            users: students
          });
        })
        .catch(error => {
          eventBus.$emit("unhandled-error", error);
        });
    },
  },
  watch: {
    loading: function(newValue) {
      if (newValue) {
        this.loader = this.$loading.show();
      } else {
        this.loader.hide();
      }
    },
  },
  async created() {
    await this.getLectors();
    await this.getStudents();

    this.loaded = true;
  }
};
</script>

<style lang="scss">
</style>